<section class="tabs">
    <ul>
        <li [ngClass]="{'active': tipoEstadisticas === 1}" (click)="showEtiquetadoresPais()">
            {{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresPais.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 2}" (click)="showEtiquetadoresDenominacion()">
            {{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresDenominacion.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 3}" (click)="showEtiquetadoresDenominaciones()">
            {{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresNDenominaciones.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 4}" (click)="showEtiquetadoresAnyo()">
            {{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.titulo' | translate}}
        </li>
    </ul>
    <content>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 1">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class="section">
                        <div>
                            <h3>{{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresPais.paises' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica1">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasEtiquetadores.grafica1.horizontal"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)" [categorias]="graficasEtiquetadores.grafica1.paises"
                                    [data]="graficasEtiquetadores.grafica1.numEtiquetadores"
                                    [valorMaximo]="graficasEtiquetadores.grafica1.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresPais.descripcionPaises' | translate)">
                                        <i class="fa-solid fa-info"></i>
                                    </button>
                                    <button 
                                    class="grid" 
                                    [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                    (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresPais.paises', dataEtiquetadores.etiquetadores_EtiquetadoresPais_Paises_1.lista, 'regularTab', 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica1">
                                <lib-simple-dougnhut-chart [labels]="graficasEtiquetadores.grafica1.paises"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [series]="graficasEtiquetadores.grafica1.numEtiquetadores"
                                    [colors]="graficasEtiquetadores.grafica1.colores">
                                </lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
                <div class="section" style="justify-content: center;">
                    <div>
                        <h3>{{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresPais.paisDenominaciones' |
                            translate}}</h3>
                    </div>
                </div>
                <div class="section">
                    <div *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica2.etiquetadores"
                        [ngClass]="{'controlDisplay': !graficasEtiquetadores.grafica2.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica2.bigWidthPes"
                                    [stackType]="'normal'" [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [info]="graficasEtiquetadores.grafica2.etiquetadores"
                                    [categorias]="graficasEtiquetadores.grafica2.categorias"
                                    [valorMaximo]="graficasEtiquetadores.grafica2.valorMaximo" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica2.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresPais.descripcionPaisDenominacion' | translate)">
                                        <i class="fa-solid fa-info"></i>
                                    </button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresPais.paisDenominaciones', dataEtiquetadores.etiquetadores_EtiquetadoresPais_PaisDenominaciones_Grid_2, 'regularTab', 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica"
                                *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica2.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica2.bigWidthPes"
                                    [stackType]="'100%'" [nombre]="'%'"
                                    [info]="graficasEtiquetadores.grafica2.porcentajes"
                                    [categorias]="graficasEtiquetadores.grafica2.categorias" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica2.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 2">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class="section">
                        <div>
                            <h3>{{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresDenominacion.denominaciones' |
                                translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica3">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasEtiquetadores.grafica3.horizontal"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [categorias]="graficasEtiquetadores.grafica3.denominaciones"
                                    [data]="graficasEtiquetadores.grafica3.numEtiquetadores"
                                    [valorMaximo]="graficasEtiquetadores.grafica3.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresDenominacion.descripcionDenominaciones' | translate)">
                                        <i class="fa-solid fa-info"></i>
                                    </button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresDenominacion.denominaciones', dataEtiquetadores.etiquetadores_EtiquetadoresDenominacion_Denominaciones_1.lista, 'regularTab', 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica3">
                                <lib-simple-dougnhut-chart [labels]="graficasEtiquetadores.grafica3.denominaciones"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [series]="graficasEtiquetadores.grafica3.numEtiquetadores"
                                    [colors]="graficasEtiquetadores.grafica3.colores"></lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
                <div class="section" style="justify-content: center;">
                    <div>
                        <h3>{{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresDenominacion.denominacionPaises' |
                            translate}}</h3>
                    </div>
                </div>
                <div class="section">
                    <div *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica4.etiquetadores"
                        [ngClass]="{'controlDisplay': !graficasEtiquetadores.grafica4.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica4.bigWidthEtq"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [stackType]="'normal'" [info]="graficasEtiquetadores.grafica4.etiquetadores"
                                    [categorias]="graficasEtiquetadores.grafica4.categorias"
                                    [valorMaximo]="graficasEtiquetadores.grafica4.valorMaximo" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica4.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresDenominacion.descripcionDenominacionPaises' | translate)">
                                        <i class="fa-solid fa-info"></i>
                                    </button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresDenominacion.denominacionPaises', dataEtiquetadores.etiquetadores_EtiquetadoresDenominacion_DenominacionPaises_Grid_2, 'regularTab', 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica"
                                *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica4.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica4.bigWidthPes"
                                    [nombre]="'%'"
                                    [stackType]="'100%'" [info]="graficasEtiquetadores.grafica4.porcentajes"
                                    [categorias]="graficasEtiquetadores.grafica4.categorias" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica4.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 3">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class="section">
                        <div>
                            <h3>{{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresNDenominaciones.nDenominaciones'
                                | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica5">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasEtiquetadores.grafica5.horizontal"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [categorias]="graficasEtiquetadores.grafica5.denominaciones"
                                    [data]="graficasEtiquetadores.grafica5.numEtiquetadores"
                                    [valorMaximo]="graficasEtiquetadores.grafica5.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresNDenominaciones.descripcionDenominaciones' | translate)">
                                        <i class="fa-solid fa-info"></i>
                                    </button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresNDenominaciones.nDenominaciones', dataEtiquetadores.etiquetadores_EtiquetadoresNumDenominaciones_NumDenominaciones_1.lista, 'regularTab', 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica5">
                                <lib-simple-dougnhut-chart [labels]="graficasEtiquetadores.grafica5.denominaciones"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [series]="graficasEtiquetadores.grafica5.numEtiquetadores"
                                    [colors]="graficasEtiquetadores.grafica5.colores"></lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
                <div class="section" style="justify-content: center;">
                    <div>
                        <h3>{{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresNDenominaciones.nDenominacionPaises'
                            | translate}}</h3>
                    </div>
                </div>
                <div class="section">
                    <div *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica6.etiquetadores"
                        [ngClass]="{'controlDisplay': !graficasEtiquetadores.grafica6.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica6.bigWidthEtq"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [stackType]="'normal'" [info]="graficasEtiquetadores.grafica6.etiquetadores"
                                    [categorias]="graficasEtiquetadores.grafica6.categorias"
                                    [valorMaximo]="graficasEtiquetadores.grafica6.valorMaximo" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica6.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresNDenominaciones.descripcionDenominacionPaises' | translate)">
                                        <i class="fa-solid fa-info"></i>
                                    </button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresNDenominaciones.nDenominacionPaises', dataEtiquetadores.etiquetadores_EtiquetadoresDenominacion_NumDenominacionPaises_Grid_2, 'regularTab', 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica"
                                *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica6.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica6.bigWidthPes"
                                    [nombre]="'%'" [stackType]="'100%'" [info]="graficasEtiquetadores.grafica6.porcentajes"
                                    [categorias]="graficasEtiquetadores.grafica6.categorias" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica6.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 4">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class="section">
                        <div>
                            <h3>{{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.anyo' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica7">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasEtiquetadores.grafica7.horizontal"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)" [categorias]="graficasEtiquetadores.grafica7.anyos"
                                    [data]="graficasEtiquetadores.grafica7.numEtiquetadores"
                                    [valorMaximo]="graficasEtiquetadores.grafica7.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.descripcionAnyo' | translate)">
                                        <i class="fa-solid fa-info"></i>
                                    </button>
                                    <button 
                                        class="grid" 
                                        [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                        (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.anyo', dataEtiquetadores.etiquetadores_EtiquetadoresAnyo_Anyos_1.lista, 'regularTab', 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica7">
                                <lib-simple-dougnhut-chart [labels]="graficasEtiquetadores.grafica7.anyos"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)" 
                                    [series]="graficasEtiquetadores.grafica7.numEtiquetadores"
                                    [colors]="graficasEtiquetadores.grafica7.colores"></lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
                <div class="section">
                    <div *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica10">
                        <div class="container">
                            <div class="grafica">
                                <lib-spline-area-chart [type]="'area'" [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [categorias]="graficasEtiquetadores.grafica10.categorias"
                                    [data]="graficasEtiquetadores.grafica10.etiquetadores"
                                    [colors]="graficasEtiquetadores.grafica10.colores"></lib-spline-area-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.descripcionAcumuladoAnyo' | translate)"><i
                                            class="fa-solid fa-info"></i></button>

                                            <button 
                                            class="grid" 
                                            [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                            (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.anyo', dataEtiquetadores.etiquetadores_EtiquetadoresAnyo_AcumuladoAnyos_Grid_1, 'regularTab', '')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
                <div class="section" style="justify-content: center;">
                    <div>
                        <h3>{{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.paisesAnyo' | translate}}</h3>
                    </div>
                </div>
                <div class="section">
                    <div *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica8.etiquetadores"
                        [ngClass]="{'controlDisplay': !graficasEtiquetadores.grafica8.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica8.bigWidthEtq"
                                    [stackType]="'normal'" [info]="graficasEtiquetadores.grafica8.etiquetadores"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [categorias]="graficasEtiquetadores.grafica8.categorias"
                                    [valorMaximo]="graficasEtiquetadores.grafica8.valorMaximo" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica8.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.descripcionPaisesAnyo' | translate)">
                                        <i class="fa-solid fa-info"></i>
                                    </button>
                                    <button 
                                            class="grid" 
                                            [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                            (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.paisesAnyo', dataEtiquetadores.etiquetadores_EtiquetadoresAnyo_PaisesAnyo_Grid_2, 'regularTab', 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica"
                                *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica8.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica8.bigWidthPes"
                                    [stackType]="'100%'" [info]="graficasEtiquetadores.grafica8.porcentajes"
                                    [nombre]="'%'"
                                    [categorias]="graficasEtiquetadores.grafica8.categorias" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica8.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
                <div class="section">
                    <div>
                        <h3>{{'centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.denominacionesAnyo' |
                            translate}}</h3>
                    </div>
                </div>
                <div class="section">
                    <div *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica9.etiquetadores"
                        [ngClass]="{'controlDisplay': !graficasEtiquetadores.grafica9.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica9.bigWidthEtq"
                                    [stackType]="'normal'" [info]="graficasEtiquetadores.grafica9.etiquetadores"
                                    [nombre]="('centralEstadisticas.etiquetadores.nEtiquetadores' | translate)"
                                    [categorias]="graficasEtiquetadores.grafica9.categorias"
                                    [valorMaximo]="graficasEtiquetadores.grafica9.valorMaximo" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica9.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button
                                        [tooltip]="('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.descripcionDenominacionesAnyo' | translate)">
                                        <i class="fa-solid fa-info"></i>
                                    </button>
                                    <button 
                                            class="grid" 
                                            [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                            (click)="showGrid('centralEstadisticas.etiquetadores.tabs.nEtiquetadoresAnyo.denominacionesAnyo', dataEtiquetadores.etiquetadores_EtiquetadoresAnyo_DenominacionesAnyo_Grid_3, 'regularTab', 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica"
                                *ngIf="graficasEtiquetadores && graficasEtiquetadores.grafica9.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasEtiquetadores.grafica9.bigWidthPes"
                                    [stackType]="'100%'" [info]="graficasEtiquetadores.grafica9.porcentajes"
                                    [nombre]="'%'"
                                    [categorias]="graficasEtiquetadores.grafica9.categorias" [showDatalabels]="true"
                                    [colors]="graficasEtiquetadores.grafica9.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </content>
</section>
<div class="modal" *ngIf="gridModal">
    <div class="modal-content">
        <header>
            <h4>{{gridTitle | translate}}</h4>
            <i class="fas fa-times" (click)="gridModal = !gridModal"></i>
          </header>
        <app-grid-estadisticas-etiquetador class="component" [title]="gridTitle" [dataGrid]="parentDataGrid" (hideTable)="hideModal()"></app-grid-estadisticas-etiquetador>
    </div>
</div>